/**
 * Auto-generated validators
 * DO NOT EDIT - Generated from actions.config.json
 * To regenerate: npm run codegen
 */

import type {
  LoginInput,
  GetTaskInput,
  UpdateBoardStatusConfigInput,
  UpdateTaskInput,
  CreateTaskInput,
  CreateBoardInput,
  CreateCommentInput,
  GetAllBoardsInput,
  GetAllOrganizationsInput,
  GetBoardInput,
  GetTaskAssignmentsInput,
  GetCommentsInput,
  GetDashboardStatsInput,
  GetNotificationsInput,
  GetOrganizationUsersInput,
  GetPreferencesInput,
  ResetUserPasswordInput,
  SwitchOrganizationInput,
  UpdateTaskStatusInput,
  UpdateUserInput,
  CreateUserInput,
  DeleteUserInput,
  GetPresignedUploadUrlInput,
  UpdateProfilePictureInput,
  ListProfilePicturesInput,
  UpdateOrgProfilePictureInput,
  ListOrgProfilePicturesInput,
  UpdateUserPreferencesInput,
  UpdateBoardBackgroundInput,
  ListBoardBackgroundsInput,
  GetBoardPreferencesInput,
  CreateTaskRelationInput,
  DeleteTaskRelationInput,
  GetTaskRelationsInput,
  GetBoardTemplatesInput,
  CreateBoardTemplateInput,
  UpdateBoardTemplateInput,
  SaveBoardAsTemplateInput,
  CreateBoardFromTemplateInput,
  UpdateBoardInput,
  SearchUsersInput,
  GetOrgConfigurationsInput,
  UpdateOrgConfigurationInput,
  DeleteBoardInput,
  DeleteTaskInput,
  UpdateOrganizationInput,
  GetUserProfileInput,
  CreateOrganizationInput,
  DeleteOrganizationInput,
  RestoreOrganizationInput,
  DeleteBoardTemplateInput,
  RestoreBoardTemplateInput,
  CreateBoardStatusInput,
  DeleteBoardStatusInput,
  RestoreBoardStatusInput,
  CreateBoardSwimlaneInput,
  DeleteBoardSwimlaneInput,
  RestoreBoardSwimlaneInput,
  RestoreBoardInput,
  RestoreTaskInput,
  MarkNotificationReadInput,
  GetScheduledJobsInput,
  CreateScheduledJobInput,
  UpdateScheduledJobInput,
  GetJobRunInput,
  GetJobRunsInput,
  RunScheduledJobInput,
  CancelJobRunInput,
  CreateUserGroupInput,
  DeleteUserGroupInput,
  GetUserGroupsInput,
  AddUserGroupMemberInput,
  BulkAddUserGroupMembersInput,
  RemoveUserGroupMemberInput,
  GetUserGroupMembersInput,
  GetUserGroupMembersBulkInput,
  GetCohortBoardInput,
  SyncCohortsInput,
  GetCohortProgressInput,
} from './processor-types';

/**
 * Runtime validator for login input
 */
export function validateLoginInput(data: unknown): data is LoginInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // username: required string
  if (typeof d.username !== 'string' || d.username.trim() === '') return false;
  if (d.username.length < 2) return false;
  if (d.username.length > 100) return false;

  // password: required string
  if (typeof d.password !== 'string' || d.password.trim() === '') return false;
  if (d.password.length < 6) return false;
  if (d.password.length > 200) return false;

  // organization_code: required string
  if (
    typeof d.organization_code !== 'string' ||
    d.organization_code.trim() === ''
  )
    return false;
  if (d.organization_code.length < 4) return false;
  if (d.organization_code.length > 4) return false;
  if (!/^[A-Z0-9]{4}$/.test(d.organization_code)) return false;

  return true;
}

/**
 * Runtime validator for get_task input
 */
export function validateGetTaskInput(data: unknown): data is GetTaskInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for update_board_status_config input
 */
export function validateUpdateBoardStatusConfigInput(
  data: unknown
): data is UpdateBoardStatusConfigInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // status_id: required string
  if (typeof d.status_id !== 'string' || d.status_id.trim() === '')
    return false;

  // config: required object
  if (typeof d.config !== 'object') return false;

  return true;
}

/**
 * Runtime validator for update_task input
 */
export function validateUpdateTaskInput(
  data: unknown
): data is UpdateTaskInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  // title: optional string
  if (d.title !== undefined) {
    if (typeof d.title !== 'string') return false;
    if ((d.title as string).length > 200) return false;
  }

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
    if ((d.description as string).length > 5000) return false;
  }

  // metadata: optional object
  if (d.metadata !== undefined && typeof d.metadata !== 'object') return false;

  // priority: optional string
  if (d.priority !== undefined) {
    if (typeof d.priority !== 'string') return false;
  }

  // estimated_pomodoros: optional number
  if (
    d.estimated_pomodoros !== undefined &&
    typeof d.estimated_pomodoros !== 'number'
  )
    return false;

  // actual_pomodoros: optional number
  if (
    d.actual_pomodoros !== undefined &&
    typeof d.actual_pomodoros !== 'number'
  )
    return false;

  // reflection: optional string
  if (d.reflection !== undefined) {
    if (typeof d.reflection !== 'string') return false;
  }

  // assignee_ids: optional array
  if (d.assignee_ids !== undefined) {
    if (!Array.isArray(d.assignee_ids)) return false;
    if (
      !d.assignee_ids.every(
        (item): item is string => typeof item === 'string' && item.trim() !== ''
      )
    )
      return false;
  }

  return true;
}

/**
 * Runtime validator for create_task input
 */
export function validateCreateTaskInput(
  data: unknown
): data is CreateTaskInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // status_id: required string
  if (typeof d.status_id !== 'string' || d.status_id.trim() === '')
    return false;

  // title: required string
  if (typeof d.title !== 'string' || d.title.trim() === '') return false;

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
  }

  // metadata: optional object
  if (d.metadata !== undefined && typeof d.metadata !== 'object') return false;

  // assignee_ids: optional array
  if (d.assignee_ids !== undefined) {
    if (!Array.isArray(d.assignee_ids)) return false;
    if (
      !d.assignee_ids.every(
        (item): item is string => typeof item === 'string' && item.trim() !== ''
      )
    )
      return false;
  }

  // priority: optional string
  if (d.priority !== undefined) {
    if (typeof d.priority !== 'string') return false;
  }

  // estimated_pomodoros: optional number
  if (
    d.estimated_pomodoros !== undefined &&
    typeof d.estimated_pomodoros !== 'number'
  )
    return false;

  // actual_pomodoros: optional number
  if (
    d.actual_pomodoros !== undefined &&
    typeof d.actual_pomodoros !== 'number'
  )
    return false;

  return true;
}

/**
 * Runtime validator for create_board input
 */
export function validateCreateBoardInput(
  data: unknown
): data is CreateBoardInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_title: required string
  if (typeof d.board_title !== 'string' || d.board_title.trim() === '')
    return false;
  if (d.board_title.length < 1) return false;
  if (d.board_title.length > 100) return false;

  // group_id: optional string
  if (d.group_id !== undefined) {
    if (typeof d.group_id !== 'string') return false;
  }

  // owner_id: required string
  if (typeof d.owner_id !== 'string' || d.owner_id.trim() === '') return false;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // columns: required non-empty array
  if (!Array.isArray(d.columns) || d.columns.length === 0) return false;

  return true;
}

/**
 * Runtime validator for create_comment input
 */
export function validateCreateCommentInput(
  data: unknown
): data is CreateCommentInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  // content: required string
  if (typeof d.content !== 'string' || d.content.trim() === '') return false;
  if (d.content.length < 1) return false;
  if (d.content.length > 1000) return false;

  return true;
}

/**
 * Runtime validator for get_all_boards input
 */
export function validateGetAllBoardsInput(
  data: unknown
): data is GetAllBoardsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for get_all_organizations input
 */
export function validateGetAllOrganizationsInput(
  data: unknown
): data is GetAllOrganizationsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // include_deleted: optional boolean
  if (d.include_deleted !== undefined && typeof d.include_deleted !== 'boolean')
    return false;

  return true;
}

/**
 * Runtime validator for get_board input
 */
export function validateGetBoardInput(data: unknown): data is GetBoardInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: optional string
  if (d.board_id !== undefined) {
    if (typeof d.board_id !== 'string') return false;
  }

  // user_id: optional string
  if (d.user_id !== undefined) {
    if (typeof d.user_id !== 'string') return false;
  }

  // dates: optional array
  if (d.dates !== undefined) {
    if (!Array.isArray(d.dates)) return false;
  }

  // page: optional number
  if (d.page !== undefined && typeof d.page !== 'number') return false;

  // page_size: optional number
  if (d.page_size !== undefined && typeof d.page_size !== 'number')
    return false;

  return true;
}

/**
 * Runtime validator for get_task_assignments input
 */
export function validateGetTaskAssignmentsInput(
  data: unknown
): data is GetTaskAssignmentsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_comments input
 */
export function validateGetCommentsInput(
  data: unknown
): data is GetCommentsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  // offset: optional number
  if (d.offset !== undefined && typeof d.offset !== 'number') return false;

  return true;
}

/**
 * Runtime validator for get_dashboard_stats input
 */
export function validateGetDashboardStatsInput(
  data: unknown
): data is GetDashboardStatsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  // organization_id: optional string
  if (d.organization_id !== undefined) {
    if (typeof d.organization_id !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for get_notifications input
 */
export function validateGetNotificationsInput(
  data: unknown
): data is GetNotificationsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // page: optional number
  if (d.page !== undefined && typeof d.page !== 'number') return false;

  return true;
}

/**
 * Runtime validator for get_organization_users input
 */
export function validateGetOrganizationUsersInput(
  data: unknown
): data is GetOrganizationUsersInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // role_filter: optional string
  if (d.role_filter !== undefined) {
    if (typeof d.role_filter !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for get_preferences input
 */
export function validateGetPreferencesInput(
  data: unknown
): data is GetPreferencesInput {
  if (typeof data !== 'object' || data === null) return false;
  return true;
}

/**
 * Runtime validator for reset_user_password input
 */
export function validateResetUserPasswordInput(
  data: unknown
): data is ResetUserPasswordInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  // user_email: optional string
  if (d.user_email !== undefined) {
    if (typeof d.user_email !== 'string') return false;
  }

  // new_password: optional string
  if (d.new_password !== undefined) {
    if (typeof d.new_password !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for switch_organization input
 */
export function validateSwitchOrganizationInput(
  data: unknown
): data is SwitchOrganizationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for update_task_status input
 */
export function validateUpdateTaskStatusInput(
  data: unknown
): data is UpdateTaskStatusInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  // status_id: required string
  if (typeof d.status_id !== 'string' || d.status_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for update_user input
 */
export function validateUpdateUserInput(
  data: unknown
): data is UpdateUserInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  // username: optional string
  if (d.username !== undefined) {
    if (typeof d.username !== 'string') return false;
  }

  // display_name: optional string
  if (d.display_name !== undefined) {
    if (typeof d.display_name !== 'string') return false;
  }

  // email: optional string
  if (d.email !== undefined) {
    if (typeof d.email !== 'string') return false;
  }

  // role: optional string
  if (d.role !== undefined) {
    if (typeof d.role !== 'string') return false;
  }

  // profile_image: optional string
  if (d.profile_image !== undefined) {
    if (typeof d.profile_image !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for create_user input
 */
export function validateCreateUserInput(
  data: unknown
): data is CreateUserInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // username: required string
  if (typeof d.username !== 'string' || d.username.trim() === '') return false;
  if (d.username.length < 2) return false;
  if (d.username.length > 50) return false;
  if (!/^[a-zA-Z0-9]+$/.test(d.username)) return false;

  // display_name: required string
  if (typeof d.display_name !== 'string' || d.display_name.trim() === '')
    return false;
  if (d.display_name.length < 1) return false;
  if (d.display_name.length > 100) return false;

  // password: required string
  if (typeof d.password !== 'string' || d.password.trim() === '') return false;
  if (d.password.length < 6) return false;
  if (d.password.length > 128) return false;

  // email: optional string
  if (d.email !== undefined) {
    if (typeof d.email !== 'string') return false;
  }

  // role: required string
  if (typeof d.role !== 'string' || d.role.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for delete_user input
 */
export function validateDeleteUserInput(
  data: unknown
): data is DeleteUserInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_presigned_upload_url input
 */
export function validateGetPresignedUploadUrlInput(
  data: unknown
): data is GetPresignedUploadUrlInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // file_name: required string
  if (typeof d.file_name !== 'string' || d.file_name.trim() === '')
    return false;
  if (d.file_name.length > 200) return false;

  // file_type: required string
  if (typeof d.file_type !== 'string' || d.file_type.trim() === '')
    return false;

  // bucket_type: required string
  if (typeof d.bucket_type !== 'string' || d.bucket_type.trim() === '')
    return false;

  // board_id: optional string
  if (d.board_id !== undefined) {
    if (typeof d.board_id !== 'string') return false;
  }

  // organization_id: optional string
  if (d.organization_id !== undefined) {
    if (typeof d.organization_id !== 'string') return false;
  }

  // expires_in: optional number
  if (d.expires_in !== undefined && typeof d.expires_in !== 'number')
    return false;

  return true;
}

/**
 * Runtime validator for update_profile_picture input
 */
export function validateUpdateProfilePictureInput(
  data: unknown
): data is UpdateProfilePictureInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // profile_image_url: required string
  if (
    typeof d.profile_image_url !== 'string' ||
    d.profile_image_url.trim() === ''
  )
    return false;
  if (d.profile_image_url.length > 500) return false;

  return true;
}

/**
 * Runtime validator for list_profile_pictures input
 */
export function validateListProfilePicturesInput(
  data: unknown
): data is ListProfilePicturesInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: optional string
  if (d.user_id !== undefined) {
    if (typeof d.user_id !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for update_org_profile_picture input
 */
export function validateUpdateOrgProfilePictureInput(
  data: unknown
): data is UpdateOrgProfilePictureInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // profile_image_url: required string
  if (
    typeof d.profile_image_url !== 'string' ||
    d.profile_image_url.trim() === ''
  )
    return false;
  if (d.profile_image_url.length > 500) return false;

  return true;
}

/**
 * Runtime validator for list_org_profile_pictures input
 */
export function validateListOrgProfilePicturesInput(
  data: unknown
): data is ListOrgProfilePicturesInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for update_user_preferences input
 */
export function validateUpdateUserPreferencesInput(
  data: unknown
): data is UpdateUserPreferencesInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // theme: optional string
  if (d.theme !== undefined) {
    if (typeof d.theme !== 'string') return false;
    if ((d.theme as string).length > 50) return false;
  }

  // mood: optional string
  if (d.mood !== undefined) {
    if (typeof d.mood !== 'string') return false;
    if ((d.mood as string).length > 100) return false;
  }

  // sizing: optional string
  if (d.sizing !== undefined) {
    if (typeof d.sizing !== 'string') return false;
    if ((d.sizing as string).length > 20) return false;
  }

  // playful_theme: optional string
  if (d.playful_theme !== undefined) {
    if (typeof d.playful_theme !== 'string') return false;
    if ((d.playful_theme as string).length > 50) return false;
  }

  // playful_sound: optional string
  if (d.playful_sound !== undefined) {
    if (typeof d.playful_sound !== 'string') return false;
    if ((d.playful_sound as string).length > 10) return false;
  }

  return true;
}

/**
 * Runtime validator for update_board_background input
 */
export function validateUpdateBoardBackgroundInput(
  data: unknown
): data is UpdateBoardBackgroundInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // background_url: optional string
  if (d.background_url !== undefined) {
    if (typeof d.background_url !== 'string') return false;
    if ((d.background_url as string).length > 500) return false;
  }

  // display_mode: optional string
  if (d.display_mode !== undefined) {
    if (typeof d.display_mode !== 'string') return false;
    if ((d.display_mode as string).length > 20) return false;
  }

  // dimensions: optional object with nested properties
  if (d.dimensions !== undefined) {
    if (typeof d.dimensions !== 'object' || d.dimensions === null) return false;
    const dimensionsObj = d.dimensions as Record<string, unknown>;
    // width: required number
    if (typeof dimensionsObj.width !== 'number') return false;

    // height: required number
    if (typeof dimensionsObj.height !== 'number') return false;
  }

  return true;
}

/**
 * Runtime validator for list_board_backgrounds input
 */
export function validateListBoardBackgroundsInput(
  data: unknown
): data is ListBoardBackgroundsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_board_preferences input
 */
export function validateGetBoardPreferencesInput(
  data: unknown
): data is GetBoardPreferencesInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for create_task_relation input
 */
export function validateCreateTaskRelationInput(
  data: unknown
): data is CreateTaskRelationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // source_task_id: required string
  if (typeof d.source_task_id !== 'string' || d.source_task_id.trim() === '')
    return false;

  // target_task_id: required string
  if (typeof d.target_task_id !== 'string' || d.target_task_id.trim() === '')
    return false;

  // relation_type: required string
  if (typeof d.relation_type !== 'string' || d.relation_type.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for delete_task_relation input
 */
export function validateDeleteTaskRelationInput(
  data: unknown
): data is DeleteTaskRelationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // relation_id: required string
  if (typeof d.relation_id !== 'string' || d.relation_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for get_task_relations input
 */
export function validateGetTaskRelationsInput(
  data: unknown
): data is GetTaskRelationsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_board_templates input
 */
export function validateGetBoardTemplatesInput(
  data: unknown
): data is GetBoardTemplatesInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // include_deleted: optional boolean
  if (d.include_deleted !== undefined && typeof d.include_deleted !== 'boolean')
    return false;

  return true;
}

/**
 * Runtime validator for create_board_template input
 */
export function validateCreateBoardTemplateInput(
  data: unknown
): data is CreateBoardTemplateInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // name: required string
  if (typeof d.name !== 'string' || d.name.trim() === '') return false;
  if (d.name.length < 1) return false;
  if (d.name.length > 100) return false;

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
    if ((d.description as string).length > 1000) return false;
  }

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // is_editable: optional boolean
  if (d.is_editable !== undefined && typeof d.is_editable !== 'boolean')
    return false;

  // config: optional object
  if (d.config !== undefined && typeof d.config !== 'object') return false;

  // columns: required non-empty array
  if (!Array.isArray(d.columns) || d.columns.length === 0) return false;

  // swimlanes: optional array
  if (d.swimlanes !== undefined) {
    if (!Array.isArray(d.swimlanes)) return false;
  }

  return true;
}

/**
 * Runtime validator for update_board_template input
 */
export function validateUpdateBoardTemplateInput(
  data: unknown
): data is UpdateBoardTemplateInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // template_id: required string
  if (typeof d.template_id !== 'string' || d.template_id.trim() === '')
    return false;

  // name: optional string
  if (d.name !== undefined) {
    if (typeof d.name !== 'string') return false;
    if ((d.name as string).length < 1) return false;
    if ((d.name as string).length > 100) return false;
  }

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
    if ((d.description as string).length > 500) return false;
  }

  // config: optional object
  if (d.config !== undefined && typeof d.config !== 'object') return false;

  // columns: optional array
  if (d.columns !== undefined) {
    if (!Array.isArray(d.columns)) return false;
  }

  // swimlanes: optional array
  if (d.swimlanes !== undefined) {
    if (!Array.isArray(d.swimlanes)) return false;
  }

  return true;
}

/**
 * Runtime validator for save_board_as_template input
 */
export function validateSaveBoardAsTemplateInput(
  data: unknown
): data is SaveBoardAsTemplateInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // template_name: required string
  if (typeof d.template_name !== 'string' || d.template_name.trim() === '')
    return false;
  if (d.template_name.length < 1) return false;
  if (d.template_name.length > 100) return false;

  // template_description: optional string
  if (d.template_description !== undefined) {
    if (typeof d.template_description !== 'string') return false;
    if ((d.template_description as string).length > 1000) return false;
  }

  return true;
}

/**
 * Runtime validator for create_board_from_template input
 */
export function validateCreateBoardFromTemplateInput(
  data: unknown
): data is CreateBoardFromTemplateInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // template_id: required string
  if (typeof d.template_id !== 'string' || d.template_id.trim() === '')
    return false;

  // board_title: required string
  if (typeof d.board_title !== 'string' || d.board_title.trim() === '')
    return false;
  if (d.board_title.length < 1) return false;
  if (d.board_title.length > 100) return false;

  // owner_id: required string
  if (typeof d.owner_id !== 'string' || d.owner_id.trim() === '') return false;

  // group_id: optional string
  if (d.group_id !== undefined) {
    if (typeof d.group_id !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for update_board input
 */
export function validateUpdateBoardInput(
  data: unknown
): data is UpdateBoardInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // title: optional string
  if (d.title !== undefined) {
    if (typeof d.title !== 'string') return false;
    if ((d.title as string).length < 1) return false;
    if ((d.title as string).length > 100) return false;
  }

  // owner_id: optional string
  if (d.owner_id !== undefined) {
    if (typeof d.owner_id !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for search_users input
 */
export function validateSearchUsersInput(
  data: unknown
): data is SearchUsersInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // query: required string
  if (typeof d.query !== 'string' || d.query.trim() === '') return false;
  if (d.query.length < 1) return false;
  if (d.query.length > 100) return false;

  return true;
}

/**
 * Runtime validator for get_org_configurations input
 */
export function validateGetOrgConfigurationsInput(
  data: unknown
): data is GetOrgConfigurationsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for update_org_configuration input
 */
export function validateUpdateOrgConfigurationInput(
  data: unknown
): data is UpdateOrgConfigurationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // config_name: required string
  if (typeof d.config_name !== 'string' || d.config_name.trim() === '')
    return false;

  // config: required object
  if (typeof d.config !== 'object') return false;

  return true;
}

/**
 * Runtime validator for delete_board input
 */
export function validateDeleteBoardInput(
  data: unknown
): data is DeleteBoardInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for delete_task input
 */
export function validateDeleteTaskInput(
  data: unknown
): data is DeleteTaskInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for update_organization input
 */
export function validateUpdateOrganizationInput(
  data: unknown
): data is UpdateOrganizationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // code: optional string
  if (d.code !== undefined) {
    if (typeof d.code !== 'string') return false;
    if ((d.code as string).length < 4) return false;
    if ((d.code as string).length > 4) return false;
  }

  // title: optional string
  if (d.title !== undefined) {
    if (typeof d.title !== 'string') return false;
    if ((d.title as string).length < 1) return false;
    if ((d.title as string).length > 100) return false;
  }

  return true;
}

/**
 * Runtime validator for get_user_profile input
 */
export function validateGetUserProfileInput(
  data: unknown
): data is GetUserProfileInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for create_organization input
 */
export function validateCreateOrganizationInput(
  data: unknown
): data is CreateOrganizationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // code: required string
  if (typeof d.code !== 'string' || d.code.trim() === '') return false;
  if (d.code.length < 4) return false;
  if (d.code.length > 4) return false;
  if (!/^[A-Z0-9]{4}$/.test(d.code)) return false;

  // title: required string
  if (typeof d.title !== 'string' || d.title.trim() === '') return false;
  if (d.title.length < 1) return false;
  if (d.title.length > 255) return false;

  // profile_image: optional string
  if (d.profile_image !== undefined) {
    if (typeof d.profile_image !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for delete_organization input
 */
export function validateDeleteOrganizationInput(
  data: unknown
): data is DeleteOrganizationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for restore_organization input
 */
export function validateRestoreOrganizationInput(
  data: unknown
): data is RestoreOrganizationInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for delete_board_template input
 */
export function validateDeleteBoardTemplateInput(
  data: unknown
): data is DeleteBoardTemplateInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // template_id: required string
  if (typeof d.template_id !== 'string' || d.template_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for restore_board_template input
 */
export function validateRestoreBoardTemplateInput(
  data: unknown
): data is RestoreBoardTemplateInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // template_id: required string
  if (typeof d.template_id !== 'string' || d.template_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for create_board_status input
 */
export function validateCreateBoardStatusInput(
  data: unknown
): data is CreateBoardStatusInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // name: required string
  if (typeof d.name !== 'string' || d.name.trim() === '') return false;
  if (d.name.length < 1) return false;
  if (d.name.length > 100) return false;

  // position: required number
  if (typeof d.position !== 'number') return false;

  // color: optional string
  if (d.color !== undefined) {
    if (typeof d.color !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for delete_board_status input
 */
export function validateDeleteBoardStatusInput(
  data: unknown
): data is DeleteBoardStatusInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // status_id: required string
  if (typeof d.status_id !== 'string' || d.status_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for restore_board_status input
 */
export function validateRestoreBoardStatusInput(
  data: unknown
): data is RestoreBoardStatusInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // status_id: required string
  if (typeof d.status_id !== 'string' || d.status_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for create_board_swimlane input
 */
export function validateCreateBoardSwimlaneInput(
  data: unknown
): data is CreateBoardSwimlaneInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // name: required string
  if (typeof d.name !== 'string' || d.name.trim() === '') return false;
  if (d.name.length < 1) return false;
  if (d.name.length > 100) return false;

  // position: required number
  if (typeof d.position !== 'number') return false;

  return true;
}

/**
 * Runtime validator for delete_board_swimlane input
 */
export function validateDeleteBoardSwimlaneInput(
  data: unknown
): data is DeleteBoardSwimlaneInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // swimlane_id: required string
  if (typeof d.swimlane_id !== 'string' || d.swimlane_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for restore_board_swimlane input
 */
export function validateRestoreBoardSwimlaneInput(
  data: unknown
): data is RestoreBoardSwimlaneInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // swimlane_id: required string
  if (typeof d.swimlane_id !== 'string' || d.swimlane_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for restore_board input
 */
export function validateRestoreBoardInput(
  data: unknown
): data is RestoreBoardInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for restore_task input
 */
export function validateRestoreTaskInput(
  data: unknown
): data is RestoreTaskInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // task_id: required string
  if (typeof d.task_id !== 'string' || d.task_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for mark_notification_read input
 */
export function validateMarkNotificationReadInput(
  data: unknown
): data is MarkNotificationReadInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // notification_id: required string
  if (typeof d.notification_id !== 'string' || d.notification_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for get_scheduled_jobs input
 */
export function validateGetScheduledJobsInput(
  data: unknown
): data is GetScheduledJobsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for create_scheduled_job input
 */
export function validateCreateScheduledJobInput(
  data: unknown
): data is CreateScheduledJobInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // job_type: required string
  if (typeof d.job_type !== 'string' || d.job_type.trim() === '') return false;

  // cron_expression: optional string
  if (d.cron_expression !== undefined) {
    if (typeof d.cron_expression !== 'string') return false;
    if ((d.cron_expression as string).length < 5) return false;
    if ((d.cron_expression as string).length > 100) return false;
  }

  // is_enabled: optional boolean
  if (d.is_enabled !== undefined && typeof d.is_enabled !== 'boolean')
    return false;

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
    if ((d.description as string).length > 500) return false;
  }

  return true;
}

/**
 * Runtime validator for update_scheduled_job input
 */
export function validateUpdateScheduledJobInput(
  data: unknown
): data is UpdateScheduledJobInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // job_id: required string
  if (typeof d.job_id !== 'string' || d.job_id.trim() === '') return false;

  // is_enabled: optional boolean
  if (d.is_enabled !== undefined && typeof d.is_enabled !== 'boolean')
    return false;

  // cron_expression: optional string
  if (d.cron_expression !== undefined) {
    if (typeof d.cron_expression !== 'string') return false;
    if ((d.cron_expression as string).length < 5) return false;
    if ((d.cron_expression as string).length > 100) return false;
  }

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
    if ((d.description as string).length > 500) return false;
  }

  return true;
}

/**
 * Runtime validator for get_job_run input
 */
export function validateGetJobRunInput(data: unknown): data is GetJobRunInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // run_id: required string
  if (typeof d.run_id !== 'string' || d.run_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_job_runs input
 */
export function validateGetJobRunsInput(
  data: unknown
): data is GetJobRunsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // job_id: required string
  if (typeof d.job_id !== 'string' || d.job_id.trim() === '') return false;

  // page: optional number
  if (d.page !== undefined && typeof d.page !== 'number') return false;

  // page_size: optional number
  if (d.page_size !== undefined && typeof d.page_size !== 'number')
    return false;

  return true;
}

/**
 * Runtime validator for run_scheduled_job input
 */
export function validateRunScheduledJobInput(
  data: unknown
): data is RunScheduledJobInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // job_id: required string
  if (typeof d.job_id !== 'string' || d.job_id.trim() === '') return false;

  // target_week: optional number
  if (d.target_week !== undefined && typeof d.target_week !== 'number')
    return false;

  // target_year: optional number
  if (d.target_year !== undefined && typeof d.target_year !== 'number')
    return false;

  return true;
}

/**
 * Runtime validator for cancel_job_run input
 */
export function validateCancelJobRunInput(
  data: unknown
): data is CancelJobRunInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // run_id: required string
  if (typeof d.run_id !== 'string' || d.run_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for create_user_group input
 */
export function validateCreateUserGroupInput(
  data: unknown
): data is CreateUserGroupInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  // name: required string
  if (typeof d.name !== 'string' || d.name.trim() === '') return false;
  if (d.name.length < 1) return false;
  if (d.name.length > 100) return false;

  // description: optional string
  if (d.description !== undefined) {
    if (typeof d.description !== 'string') return false;
  }

  return true;
}

/**
 * Runtime validator for delete_user_group input
 */
export function validateDeleteUserGroupInput(
  data: unknown
): data is DeleteUserGroupInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_id: required string
  if (typeof d.group_id !== 'string' || d.group_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_user_groups input
 */
export function validateGetUserGroupsInput(
  data: unknown
): data is GetUserGroupsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for add_user_group_member input
 */
export function validateAddUserGroupMemberInput(
  data: unknown
): data is AddUserGroupMemberInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_id: required string
  if (typeof d.group_id !== 'string' || d.group_id.trim() === '') return false;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for bulk_add_user_group_members input
 */
export function validateBulkAddUserGroupMembersInput(
  data: unknown
): data is BulkAddUserGroupMembersInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_id: required string
  if (typeof d.group_id !== 'string' || d.group_id.trim() === '') return false;

  // user_ids: required non-empty array
  if (!Array.isArray(d.user_ids) || d.user_ids.length === 0) return false;
  if (
    !d.user_ids.every(
      (item): item is string => typeof item === 'string' && item.trim() !== ''
    )
  )
    return false;

  return true;
}

/**
 * Runtime validator for remove_user_group_member input
 */
export function validateRemoveUserGroupMemberInput(
  data: unknown
): data is RemoveUserGroupMemberInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_id: required string
  if (typeof d.group_id !== 'string' || d.group_id.trim() === '') return false;

  // user_id: required string
  if (typeof d.user_id !== 'string' || d.user_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_user_group_members input
 */
export function validateGetUserGroupMembersInput(
  data: unknown
): data is GetUserGroupMembersInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_id: required string
  if (typeof d.group_id !== 'string' || d.group_id.trim() === '') return false;

  return true;
}

/**
 * Runtime validator for get_user_group_members_bulk input
 */
export function validateGetUserGroupMembersBulkInput(
  data: unknown
): data is GetUserGroupMembersBulkInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_ids: required non-empty array
  if (!Array.isArray(d.group_ids) || d.group_ids.length === 0) return false;
  if (
    !d.group_ids.every(
      (item): item is string => typeof item === 'string' && item.trim() !== ''
    )
  )
    return false;

  return true;
}

/**
 * Runtime validator for get_cohort_board input
 */
export function validateGetCohortBoardInput(
  data: unknown
): data is GetCohortBoardInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // group_id: required string
  if (typeof d.group_id !== 'string' || d.group_id.trim() === '') return false;

  // organization_id: required string
  if (typeof d.organization_id !== 'string' || d.organization_id.trim() === '')
    return false;

  return true;
}

/**
 * Runtime validator for sync_cohorts input
 */
export function validateSyncCohortsInput(
  data: unknown
): data is SyncCohortsInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // week_number: required number
  if (typeof d.week_number !== 'number') return false;

  // year: required number
  if (typeof d.year !== 'number') return false;

  return true;
}

/**
 * Runtime validator for get_cohort_progress input
 */
export function validateGetCohortProgressInput(
  data: unknown
): data is GetCohortProgressInput {
  if (typeof data !== 'object' || data === null) return false;
  const d = data as Record<string, unknown>;

  // board_id: required string
  if (typeof d.board_id !== 'string' || d.board_id.trim() === '') return false;

  // week_number: required number
  if (typeof d.week_number !== 'number') return false;

  // year: required number
  if (typeof d.year !== 'number') return false;

  return true;
}
